"use strict";
export {};
//# sourceMappingURL=IConfiguration.js.map